var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRoles = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M481.7,304.7c-76.8,0-152.7,0-228.5,0c-8.8-34,0.3-55.1,31.6-69.3c51.8-23.5,104.6-25.1,157.4-3.2 C478.4,247.3,486.7,262.8,481.7,304.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,73.3c32.5,0.2,57.7,26,57.4,58.8c-0.2,33.3-26.1,58.7-59.6,58.3c-32.6-0.4-57.7-26.1-57.5-58.9 C308.5,98.3,334.4,73,368,73.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.3,426.7c-102.1,0-203.2,0-304,0c-11.8-45.2,0.4-73.3,42.1-92.2c69-31.3,139.1-33.4,209.4-4.2 C320.8,350.3,331.9,371,325.3,426.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.9,118.8c43.2,0.3,76.7,34.6,76.4,78.2c-0.3,44.3-34.8,78-79.3,77.6c-43.3-0.5-76.8-34.7-76.5-78.3 C94.8,152.1,129.3,118.5,173.9,118.8z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/roles.33d1b840.svg";
export { ForwardRef as ReactComponent };